import { takeEvery, channel } from 'redux-saga'
import { put, call, take, fork } from 'redux-saga/effects'
import { WAIT_FOR_MAP_IDLE } from 'actions/applicationActionTypes'
import { updateUiAction } from 'actions/uiActions'

function * waitForIdle(idleChannel) {
  const action = yield take(idleChannel)
  yield put(updateUiAction({ mapLoaded: true }))
}

export function * waitForMapIdle(action) {
  const { map } = action
  const idleChannel = yield call(channel)

  yield put(updateUiAction({ mapLoaded: false }))
  google.maps.event.addListenerOnce(map, 'idle', _ => {
    idleChannel.put(updateUiAction({ mapLoaded: true }))
  })

  yield fork(waitForIdle, idleChannel)
}

export function * watchWaitForMapIdle() {
  yield * takeEvery(WAIT_FOR_MAP_IDLE, waitForMapIdle)
}




// WEBPACK FOOTER //
// ./src/sagas/waitForMapIdleSaga.js